import capitalize from "lodash/capitalize";

const capitalizedName = (name: string): string =>
  name
    .split(" ")
    .map((item) => capitalize(item))
    .join(" ");
export default capitalizedName;
